export default __webpack_public_path__ + "static/media/miguel-lopes-45.05aed471.jpg";